import { Tabs, TabsList, TabsTrigger } from './tabs';

type DashboardSectionTabsItem = {
  id: string;
  label: string;
};

type DashboardSectionTabsProps = {
  items: DashboardSectionTabsItem[];
  value: string;
  onValueChange: (value: string) => void;
  className?: string;
};

export function DashboardSectionTabs({
  items,
  value,
  onValueChange,
  className,
}: DashboardSectionTabsProps) {
  if (items.length === 0) {
    return null;
  }

  return (
    <Tabs value={value} onValueChange={onValueChange} className={className ?? 'w-full sm:w-auto'}>
      <TabsList variant="secondary" className="inline-flex w-auto max-w-full flex-wrap">
        {items.map((item) => (
          <TabsTrigger key={item.id} variant="secondary" value={item.id}>
            {item.label}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
}
